module.exports = __webpack_public_path__ + "img/symbol_starblack.21d16529.png";